import AbstractApiService from 'src/services/abstractApiService';
import { AUTH_URL, DOC2API_URL, api } from 'pages/APIs';

export default class SupplierOrganisationApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async getApprovedSupplierOrganisations(data: FormData): Promise<any> {
    const formData = data;
    return super.post(api.get_approved_supplier_organisations, formData);
  }
}
